<template>
  <div class="bill">
    <!-- <van-nav-bar title="常见问题"
                 left-text="关闭"
                 left-arrow
                 @click-left="onClickLeft" /> -->

    <div class='bill_content'>
      <div class='bill_main'>
        <div class='bill_kind'>
          <div class='bill_kind_title'>
            1.发票类型有哪些？
          </div>
          <div class='bill_kind_content'>
            目前可以开具电子增值税务普通发票（简称“电子发票”）、纸质增值税普通发票（简称:"纸质发票"）、以及增值税专用发票（简称"专业发票"）。
          </div>
        </div>
        <div class='bill_kind'>
          <div class='bill_kind_title'>
            1.发票类型有哪些？
          </div>
          <div class='bill_kind_content'>
            目前可以开具电子增值税务普通发票（简称“电子发票”）、纸质增值税普通发票（简称:"纸质发票"）、以及增值税专用发票（简称"专业发票"）。
          </div>
        </div>
        <div class='bill_kind'>
          <div class='bill_kind_title'>
            1.发票类型有哪些？
          </div>
          <div class='bill_kind_content'>
            目前可以开具电子增值税务普通发票（简称“电子发票”）、纸质增值税普通发票（简称:"纸质发票"）、以及增值税专用发票（简称"专业发票"）。
          </div>
        </div>
        <div class='bill_kind'>
          <div class='bill_kind_title'>
            1.发票类型有哪些？
          </div>
          <div class='bill_kind_content'>
            目前可以开具电子增值税务普通发票（简称“电子发票”）、纸质增值税普通发票（简称:"纸质发票"）、以及增值税专用发票（简称"专业发票"）。
          </div>
        </div>
        <div class='bill_kind'>
          <div class='bill_kind_title'>
            1.发票类型有哪些？
          </div>
          <div class='bill_kind_content'>
            目前可以开具电子增值税务普通发票（简称“电子发票”）、纸质增值税普通发票（简称:"纸质发票"）、以及增值税专用发票（简称"专业发票"）。
          </div>
        </div>
        <div class='bill_kind'>
          <div class='bill_kind_title'>
            1.发票类型有哪些？
          </div>
          <div class='bill_kind_content'>
            目前可以开具电子增值税务普通发票（简称“电子发票”）、纸质增值税普通发票（简称:"纸质发票"）、以及增值税专用发票（简称"专业发票"）。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import store from '@/vuex/store'
import { mapState } from 'vuex'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import { fdatasync } from 'fs';
//import {eventBus} from '../../assets/js/eventBus'

export default {
  name: 'aboutBill',
  store,
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="less" >
.bill {
  background: rgb(247, 247, 247);

  & > * {
    font-size: 0.24rem;
  }

  .bill_content {
    height: 100%;
    background: rgb(247, 247, 247);
    padding: 0.3rem;

    .bill_main {
      border-radius: 0.2rem;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.14);
      background: #fff;
      padding: 0.4rem;

      .bill_kind {
        margin-bottom: 0.42rem;
        .bill_kind_title {
          color: rgb(255, 144, 0);
          margin-bottom: 0.12rem;
        }
        .bill_kind_content {
          color: rgb(102, 102, 102);
          letter-spacing: 2px;
          line-height: 0.4rem;
        }
      }
    }
  }
  .van-nav-bar .van-icon {
    display: none;
  }
  .van-nav-bar__text {
    color: #000;
  }
  .van-nav-bar__title {
    font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/bill/aboutBill.vue